import React, {useEffect} from 'react';
import SearchBar from "../components/SearchBar";
import {useNavigate} from "react-router-dom";

import ServiceGroups from "../components/ServiceGroups";

import Navbar from "../../../layouts/Navbar";
const AllCategoriesPage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;

    useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            if(config.service_app_settings.need_login > 0 ) {
                navigate('/login');
            }
        }

    }, []);

    return (
        <div className='mt-md-5'>
            <SearchBar />

            <ServiceGroups showAll={true}  />

            <Navbar/>
        </div>
    );
};

export default AllCategoriesPage;